export const AUTH_LANGUAGE_STORAGE_KEY = 'disasterms.auth.language';

export const readAuthLanguage = () => {
  if (typeof window === 'undefined') return 'en';

  try {
    const storedLanguage = window.localStorage.getItem(AUTH_LANGUAGE_STORAGE_KEY);
    return storedLanguage === 'ar' ? 'ar' : 'en';
  } catch {
    return 'en';
  }
};

export const persistAuthLanguage = (language) => {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(
      AUTH_LANGUAGE_STORAGE_KEY,
      language === 'ar' ? 'ar' : 'en',
    );
  } catch {
    // The auth flow remains usable when browser storage is unavailable.
  }
};
